import styled from 'styled-components'
import { VehicleServiceStatus } from 'models/Vehicles/VehicleStateModel'
import { theme } from 'styles/theme'

interface ServiceStatusLook {
    title: string
    // The text and dot color
    color: string
    borderColor: string
    backgroundColor: string
}

// Also used for the options of the change status popup
export const serviceStatusLooks: Record<VehicleServiceStatus, ServiceStatusLook> = {
    [VehicleServiceStatus.OutOfService]: { title: 'Out of service', color: '#C00F0C', borderColor: '#C00F0C', backgroundColor: '#FDF2F0' },
    [VehicleServiceStatus.InService]: { title: 'In service', color: '#009951', borderColor: '#009951', backgroundColor: '#EBFFEE' },
    [VehicleServiceStatus.Parked]: { title: 'Parked', color: theme.colors.SecondaryGrey, borderColor: '#434343', backgroundColor: theme.colors.MediumGrey },
}

// In the order shown in the change status popup
export const SERVICE_STATUSES = [VehicleServiceStatus.OutOfService, VehicleServiceStatus.InService, VehicleServiceStatus.Parked]

const Pill = styled.span<{ $look: ServiceStatusLook }>`
    display: inline-block;
    align-self: center;
    padding: 6px 10px;
    border: 1px solid ${({ $look }) => $look.borderColor};
    border-radius: ${theme.radii.large};
    background-color: ${({ $look }) => $look.backgroundColor};
    color: ${({ $look }) => $look.color};
    font-size: ${theme.fontSizes.smaller};
    font-weight: ${theme.fontWeights.semiBold};
    line-height: 16px;
    letter-spacing: 0.03em;
    white-space: nowrap;
`

interface VehicleServiceStatusBadgeProps {
    // undefined when the vehicle state is not known, which shows nothing
    serviceStatus: VehicleServiceStatus | undefined
}

export const VehicleServiceStatusBadge = ({ serviceStatus }: VehicleServiceStatusBadgeProps) => {
    if (serviceStatus === undefined) {
        return null
    }
    const look = serviceStatusLooks[serviceStatus]
    return <Pill {...{ $look: look }}>{ look.title }</Pill>
}
